import { UIMessageMetadata } from '../UIMessage/UIMessageMetadata';

export const isMissedCall = (missedCallType: string) =>
    Boolean(MissedCallTypes[missedCallType as MissedCallTypes]);

export interface MissedCallMetadataContent extends UIMessageMetadata {
    type: MissedCallTypes;
    data: {
        caller: number;
        callee: number;
    };
}

export type MissedCallMessageMetadata = {
    metadata: MissedCallMetadataContent;
};

export enum AttendeeType {
    HOST = 'HOST',
    GUEST = 'GUEST',
}

export enum MissedCallTypes {
    CALL_DECLINED = 'CALL_DECLINED',
    CALL_TIMEOUT = 'CALL_TIMEOUT',
    CALL_CANCELED = 'CALL_CANCELED',
    GUEST_BUSY = 'GUEST_BUSY',
}
